/* eslint-disable react/display-name */
import React from 'react';
import { Tooltip } from 'antd';
import _ from 'lodash';
import { User } from '@shared/types/users';
import { UserRoles } from '@shared/types/auth';
import { rolesMap } from '@shared/constants/rolesList';

export const getValueWithTooltip =
  <T extends Record<string, T[keyof T]>>(
    fieldName: keyof T,
    lengthForTooltip: number,
    path?: string,
    replaceValue?: string
  ) =>
  (row: T) => {
    const fieldValue = (_.get(row, (fieldName as string) + (path ? `.${path}` : '')) ||
      replaceValue) as unknown as string;
    const tooltipText = <span className="text-1424 text-black">{fieldValue}</span>;
    const shouldShowTooltip = fieldValue?.length > lengthForTooltip;

    return (
      <Tooltip
        color="white"
        title={shouldShowTooltip ? tooltipText : ''}
      >
        <div className="max-w-full truncate bg-transparent">{fieldValue}</div>
      </Tooltip>
    );
  };
export const getRolesWithTooltip = (lengthForTooltip: number) => (row: User) => {
  const rolesExceptAdmin = row.roles.filter(role => role !== UserRoles.ADMIN);
  const tooltipText = rolesExceptAdmin.map(role => rolesMap[role]?.label ?? role).join(', ');
  const shouldShowTooltip = tooltipText?.length > lengthForTooltip;
  const trimmedText = tooltipText.substring(lengthForTooltip, tooltipText.length - 1);
  const overflowCount = trimmedText.split(', ').length - 1;
  return tooltipText ? (
    <Tooltip
      color="white"
      title={shouldShowTooltip && <span className="text-1424 text-black">{tooltipText}</span>}
    >
      <div className="flex w-full items-center justify-between">
        <div className="max-w-full truncate bg-transparent">{tooltipText}</div>
        {shouldShowTooltip && overflowCount > 0 && (
          <div className="border-brightGray ml-[4px] flex max-h-[32px] min-h-[32px] min-w-[32px] max-w-[32px] items-center justify-center rounded-[100%] border-[1px] bg-white">
            {`+${overflowCount}`}
          </div>
        )}
      </div>
    </Tooltip>
  ) : (
    '-'
  );
};
